<template>
  <div>
    <div class="mainpage-header">
      <div style="vertical-align: baseline; float: left">
        <router-link to="/">
          <img class="app-logo" src="https://gcdn.bionluk.com/site/general/bionluk_logo_gk.png">
        </router-link>
      </div>
      <div v-if="!user.uuid" style="float: right;">
        <div v-if="!openCloseLoginForm" @click="openCloseLoginForm = true">
          <img src="https://gcdn.bionluk.com/site/icon/tansel_mobile_menu_black.svg"/>
        </div>
        <div v-if="openCloseLoginForm" @click="openCloseLoginForm = false">
          <img src="https://gcdn.bionluk.com/site/icon/tansel_mobile_menu_close_black.svg"/>
        </div>
      </div>
    </div>
    <div class="settings" v-if="user.uuid || !openCloseLoginForm" style=" padding-top: 60px; min-width: 100vw">
      <div>
        <div class="pro-landing-header">
          <div style="margin-top: 40px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <p class="header-title">
              bicoin<span style="font-weight: 300;">’leri Toplayın;<br> Öncelik, Zaman ve Görünürlük Kazanın</span>
            </p>
            <p class="header-description">
              Bionluk’ta yaptığın her satış, sana bicoin olarak geri döner. Hesabında biriken bicoin’lerini, iş ilanlarını öne çıkarmak veya sana hiç mesaj göndermemiş kullanıcılarla iletişime geçmek için kullanabilirsin.

            </p>

          </div>
        </div>
        <div class="bicoin-how-works-body">
          <div class="how-works-main">
            <p class="how-works-title">Nasıl çalışır?</p>
            <div style="display: flex; flex-direction: column; margin-top: 20px; margin-bottom: 30px;">
              <div class="work-desc-main" v-for="work in howWorksArray">
                <img :src="work.imageUrl"/>
                <p class="work-title">{{work.title}}</p>
                <p class="work-description">{{work.description}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="faq-body">
          <p class="faq-title">Sıkça sorulan sorular</p>
          <div class="faq-main">
            <div class="faq-array-div" v-for="faq in faqs">
              <div v-if="!faq.open" class="faq-close-div" @click="reverseFaq(faq)">
                <p>{{faq.question}}</p>
                <img src="https://gcdn.bionluk.com/site/icon/tansel_f_o_altok.svg"/>
              </div>
              <div v-if="faq.open" class="faq-open-div" @click="reverseFaq(faq)">
                <div style="display: flex; justify-content: space-between;">
                  <p class="faq-open-question">{{faq.question}}</p>
                  <img class="faq-open-image" src="https://gcdn.bionluk.com/site/icon/tansel_f_o_ustok.svg"/>
                </div>
                <p class="faq-open-answer">{{faq.answer}}</p>
              </div>
            </div>
          </div>
          <div class="faq-bottom">

            <div><router-link style="color: white" to="/panel/bicoin">bicoin hesabıma git!</router-link></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!user.uuid && openCloseLoginForm" class="mainpage-mobile-login-form">

      <button class="super-button-light login-form-button-explore"
              @click="$router.push('/freelancer-bul')">Bionluk'u Keşfet
      </button>
      <div style="width: 120px; height: 2px;border-bottom: solid 1px #dde3eb; margin-top: 31px; margin-bottom: 29px;"></div>
      <button class="super-button-light login-form-button-freelancer"
              @click="$router.push('/register')">Freelancer Ol
      </button>
      <button class="super-button login-form-button-login"
              @click="$router.push('/login')">Giriş / Kaydol
      </button>
      <div style="width: 271px; height: 3px; border-bottom: solid 1px #dde3eb; margin-top: 85px;"></div>

      <div>
        <div style="margin-top: 20px; margin-bottom: 20px;display: flex;align-items: center">
          <div style="cursor: pointer;">
            <a href="https://facebook.com/bionluk" target="_blank">
              <img src="https://gcdn.bionluk.com/site/icon/tansel_mobile_facebook_gri.svg"/>
            </a>
          </div>

          <div style="cursor: pointer; margin-left: 30px;;">
            <a href="https://twitter.com/bionluk" target="_blank">
              <img src="https://gcdn.bionluk.com/site/icon/tansel_mobile_twitter_gri.svg"/>
            </a>
          </div>

          <div style="cursor: pointer; margin-left: 30px;">
            <a href="https://instagram.com/bionlukcom" target="_blank">
              <img src="https://gcdn.bionluk.com/site/icon/tansel_mobile_instagram_gri.svg"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "src-pages-body-main-bicoin-bicoin_mobile",
    data() {
      return {
        howWorksArray: [
          {
            imageUrl: 'https://gcdn.bionluk.com/site/icon/tansel_f_o_3.png',
            title: 'Çalıştıkça Birikir',
            description: 'Bionluk’taki çalışma performansınla doğru orantılı olarak bicoin kazanırsın ve her satış yaptığında bicoin’lerin hesabına yüklenir. '
          },
          {
            imageUrl: 'https://gcdn.bionluk.com/site/icon/tansel_f_o_2.png',
            title: 'Görünürlük ve Zaman Kazandırır',
            description: 'Biriken bicoin’lerini arama sayfalarında listelenen ilanlar arasında öne çıkmak veya sana hiç mesaj göndermemiş kullanıcılarla iletişime geçmek için kullanırsın.\n'
          },
          {
            imageUrl: 'https://gcdn.bionluk.com/site/icon/tansel_f_o_1.png',
            title: 'İşleri Artırır',
            description: 'Görünürlüğün arttıkça daha fazla iş almaya ve bitirdiğin işler sonucunda daha fazla bicoin kazanmaya başlarsın. '
          },
        ],
        faqs: [
          {
            open: false,
            question: 'bicoin nedir?',
            answer: 'bicoin; Bionluk üyesi freelancer’ların Bionluk’ta yaptıkları satışlar sayesinde bakiye kazandıkları özel bir kullanıcı programıdır. bicoin hesabına yüklenen bicoin’ler sadece Bionluk’ta harcanabilir.'
          },
          {
            open: false,
            question: 'bicoin parayla satılır mı?',
            answer: 'bicoin parayla satılamaz, takas veya transfer edilemez. Bionluk’taki satış performansına bağlı olarak yalnızca Bionluk tarafından bicoin hesabına yüklenir. bicoin hesabına, freelancer olarak Bionluk’a giriş yaptıktan sonra ana sayfada bulunan “Freelancer” panelinden ulaşabilirsin.'
          },
          {
            open: false,
            question: 'Nasıl bicoin kazanılır?',
            answer: 'Bionluk’ta onaylanan satışlarından kazandığın her 1 TL için 1 bicoin kazanırsın. Örneğin 100 TL tutarında bir satış yaptığında, 100 bicoin otomatik olarak hesabına yüklenir.'
          },
          {
            open: false,
            question: 'Nasıl bicoin harcanır?',
            answer: 'Bicoin harcamanın en önemli avantajı, sana satışlarını artırma imkânı vermesidir. Biriktirdiğin bicoin’leri bicoin hesabındaki “bicoin’leri kullan” butonuna tıklayarak değerlendirebilirsin. bicoin’leri değerlendirmenin iki yolu vardır: 1-) Kategori sayfalarında alıcılar için listelenen ilanlar arasında, iş ilanını öne çıkararak görünürlüğünü artırmak.  \n' +
            '\n' +
            '2-) Henüz sana hiç mesaj göndermemiş kullanıcılarla iletişime geçmek'
          },
          {
            open: false,
            question: 'Öne çıkma özelliği nasıl kullanılır?',
            answer: 'Alıcılar tarafından görüntülenen iş ilanları arasından kendi iş ilanını daha görünür kılmak için “Öne Çıkma” özelliğinden faydalanabilirsin. 500 bicoin harcayarak iş ilanını listeleme sayfalarında en üst sıraya taşıyabilirsin. Bu alandaki ilanlar gün içinde değişmekle birlikte üst sıraya taşıdığın iş ilanların, 24 saat boyunca dönüşümlü olarak öne çıkanlar arasında sergilenir. '
          }
        ],
        openCloseLoginForm: false,
      }
    },

    methods: {
      reverseFaq(faq) {
        faq.open = !faq.open;
      }
    },

    watch: {},

    created() {

    }

  }
</script>

<style scoped lang="scss">
  .mainpage-header {
    padding-top: 20px;
    padding-right: 15px;
    padding-left: 13px;
  }

  .app-logo {
    height: 28px;
    margin-top: 2px;
  }

  /*login part*/
  .mainpage-mobile-login-form {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
    width: 100vw;
    height: 90vh
  }

  .mainpage-mobile-login-form {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
    width: 100vw;
    height: 90vh
  }

  .login-form-button-explore {
    width: 270px;
    height: 50px;
    border-radius: 2px;
    border: solid 1px #bfc8d2;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #2d3640;
  }

  .login-form-button-freelancer {
    width: 270px;
    height: 50px;
    border-radius: 2px;
    border: solid 1px #2d3640;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #2d3640;
  }

  .login-form-button-login {
    width: 270px;
    height: 50px;
    border-radius: 2px;
    background-color: #2d3640;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    margin-top: 10px;
  }

  /*header*/

  .pro-landing-header {
    margin: 0 auto;
    text-align: center;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .header-title {
      font-size: 32px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #2d3640;

    }
    .header-description {
      width: 291px;
      margin-top: 20px;
      font-size: 18px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.44;
      letter-spacing: normal;
      color: #8b95a1;

    }

    .header-button {
      width: 193px;
      height: 50px;
      border-radius: 2px;
      background-color: #fd4056;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
      line-height: 50px;
      cursor: pointer;
    }
  }

  .bicoin-how-works-body {
    min-width: 100vw;
    padding-top: 30px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .how-works-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 100vw;
    background-color: #fff;
    .how-works-title {
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      margin-top: 44px;
    }
  }

  .work-desc-main {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }

    img {
      width: 89px;
      height: 89px;
    }
    .work-title {
      margin-top: 0px;
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      color: #2d3640;
    }

    .work-description {
      margin-top: 10px;
      width: 300px;
      height: 100px;
      overflow: hidden;
      font-size: 16px;
      line-height: 1.5;
      text-align: center;
      color: #8b95a1;
    }

  }

  .faq-body {
    min-width: 100vw;
    padding-bottom: 53px;
    padding-top: 31px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    .faq-title {
      font-size: 26px;
      font-weight: 600;
      text-align: center;
      color: #333333;
    }
  }

  .faq-main {
    display: flex;
    flex-direction: column;
    margin-top: 43px;
    .faq-array-div {
      width: 100vw;
    }
  }

  .faq-close-div {
    border-top: solid 1px #e0e0e0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px 17px 14px 20px;
    cursor: pointer;
    p {
      font-size: 16px;
      text-align: left;
      color: #2d3640;
    }
  }

  .faq-open-div {
    border-top: solid 1px #e0e0e0;
    padding: 25px 17px 35px 20px;
    background-color: #f1f2f4;
    cursor: pointer;
    .faq-open-question {
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      color: #2d3640;
    }

    .faq-open-answer {
      font-size: 14px;
      line-height: 1.43;
      text-align: left;
      color: #8b95a1;
      margin-top: 16px;
    }
  }

  .faq-bottom {
    border-top: solid 1px #e0e0e0;
    width: 100vw;
    height: 201px;
    background: url('https://gcdn.bionluk.com/site/icon/freelancer_olmak_bg_alt.png');
    background-position: center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      color: #2d3640;
      width: 230px;
    }

    div {
      width: 200px;
      height: 50px;
      margin-top: 20px;
      border-radius: 2px;
      background-color: #fd4056;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
      line-height: 50px;
      cursor: pointer;
    }
  }

</style>
